@if (appointmentDtos != undefined && this.patientManagementService.locationDetailDtos) {
  <div class="page-column">
    <div class="title">
      <div class="typo-h2">
        {{ "profile.appointments.title" | transloco }}
      </div>

      @if (patientManagementService.onlineBookingUrlDtos && patientManagementService.onlineBookingUrlDtos.length > 0) {
        @if (patientManagementService.onlineBookingUrlDtos.length == 1) {
          <app-icon-button [matMenuTriggerFor]="menu" colorVariant="primary" icon="add" size="big"/>
          <mat-menu #menu="matMenu">
            @for (onlineBookingUrl of patientManagementService.onlineBookingUrlDtos[0].onlineBookingUrls; track onlineBookingUrl; let lastUrl = $last) {
              <a [href]="onlineBookingUrl.link" mat-menu-item>{{ onlineBookingUrl.name | localizedText }}</a>
              @if (!lastUrl) {
                <mat-divider/>
              }
            }
          </mat-menu>
        } @else {
          <app-icon-button [matMenuTriggerFor]="menu" colorVariant="primary" icon="add" size="big"/>
          <mat-menu #menu="matMenu">
            @for (onlineBookingUrlDto of patientManagementService.onlineBookingUrlDtos; track onlineBookingUrlDto; let lastLocation = $last) {
              <button [matMenuTriggerFor]="subMenu" mat-menu-item>
                <div class="menu-item">
                  <div>{{ onlineBookingUrlDto.locationName }}</div>
                  <div>{{ onlineBookingUrlDto.locationZipCode }} {{ onlineBookingUrlDto.locationCity }}</div>
                </div>
              </button>
              @if (!lastLocation) {
                <mat-divider/>
              }

              <mat-menu #subMenu="matMenu">
                @for (onlineBookingUrl of onlineBookingUrlDto.onlineBookingUrls; track onlineBookingUrl; let lastUrl = $last) {
                  <a [href]="onlineBookingUrl.link" mat-menu-item>{{ onlineBookingUrl.name | localizedText }}</a>
                  @if (!lastUrl) {
                    <mat-divider/>
                  }
                }
              </mat-menu>
            }
          </mat-menu>
        }
      }
    </div>

    <div class="appointment-list">
      @for (appointmentDto of appointmentDtos; track appointmentDto) {
        @if (appointmentDto.isDeleted) {
          <button (click)="open(appointmentDto)" class="appointment-item-deleted" matRipple>
            <div class="info-row">
              <div class="appointment-deleted">
                <div class="text-row">
                  <div class="white body-text-bold">{{ appointmentDto.startTime | customDate:'ccc dd.MM.yyyy' }}</div>
                  <div class="white body-text-bold">{{ appointmentDto.startTime | customDate:'HH:mm' }} - {{ appointmentDto.endTime | customDate:'HH:mm' }}</div>
                </div>
                <div class="white body-text align">{{ appointmentDto.locationId | locationName }}</div>
                @if (appointmentDto.employeeName) {
                  <div class="white body-text align">{{ appointmentDto.employeeName }}</div>
                }
              </div>
              <mat-icon class="chevron chevron-cancelled">keyboard_arrow_right</mat-icon>
            </div>
            <div class="deleted-row">
              <div class="body-text-small-bold cancelled-dark">{{ "profile.appointments.deleted" | transloco }}</div>
              <mat-icon class="cancelled-dark">block</mat-icon>
            </div>
          </button>
        } @else {
          <button (click)="open(appointmentDto)" class="appointment-item" matRipple>
            <div class="appointment">
              <div class="text-row">
                <div class="secondary body-text-bold">{{ appointmentDto.startTime | customDate:'ccc dd.MM.yyyy' }}</div>
                <div class="body-text-bold">{{ appointmentDto.startTime | customDate:'HH:mm' }} - {{ appointmentDto.endTime | customDate:'HH:mm' }}</div>
              </div>
              <div class="body-text align">{{ appointmentDto.locationId | locationName }}</div>
              @if (appointmentDto.employeeName) {
                <div class="body-text align">{{ appointmentDto.employeeName }}</div>
              }
            </div>
            <mat-icon class="chevron chevron-secondary">keyboard_arrow_right</mat-icon>
          </button>
        }
      }
    </div>
  </div>
}
